var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map_box"},[_c('div',{attrs:{"id":"tmap"}}),_c('el-button',{staticClass:"btn",attrs:{"size":"small"},on:{"click":_vm.showMarker}},[_vm._v("显示多个标记")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }